import React from 'react';
import { useSelector } from 'react-redux';
import { Text } from '@rsos/components/capstone/base';
import { VERIFIED } from '../../../constants/issueStatuses';
import formatDate from '../formatDate';
import {
  ShapeFilesDetailsTable,
  ShapeFilesDetailsTableTD,
  ShapeFilesDetailsTableTH,
  ShapeFilesDetailsTableTR,
  ShapeFilesDetailsTableBody,
  ShapeFilesDetailsTableHead,
  NameContainer,
} from './ShapeFilesDetails.styles';
import StatusBadge from './StatusBadge/';
import { determineAction } from './utils';

const ShapeFilesDetails = ({ handleReview, handleView }) => {
  const issues = useSelector(state => state.issues);
  const psap = useSelector(state => state.psaps);

  return (
    <ShapeFilesDetailsTable>
      <ShapeFilesDetailsTableHead>
        <ShapeFilesDetailsTableTR>
          <ShapeFilesDetailsTableTH>Name</ShapeFilesDetailsTableTH>
          <ShapeFilesDetailsTableTH>Status</ShapeFilesDetailsTableTH>
          <ShapeFilesDetailsTableTH>Submitted</ShapeFilesDetailsTableTH>
          <ShapeFilesDetailsTableTH>Action</ShapeFilesDetailsTableTH>
        </ShapeFilesDetailsTableTR>
      </ShapeFilesDetailsTableHead>
      <ShapeFilesDetailsTableBody>
        {issues.records.map(issue => (
          <ShapeFilesDetailsTableTR key={issue.issue_key}>
            <ShapeFilesDetailsTableTD>
              <NameContainer>
                <Text size="normal" color="secondaryText" ellipsis>
                  {issue.shapefile_name}
                </Text>
                {issue.status === VERIFIED && (
                  <Text size="xsmall" color="heavyWarning" mt="3px">
                    We are in the process of activating your file. You will be
                    able to use jurisdiction view once your file is active.
                  </Text>
                )}
              </NameContainer>
            </ShapeFilesDetailsTableTD>
            <ShapeFilesDetailsTableTD>
              <StatusBadge status={issue.status} />
            </ShapeFilesDetailsTableTD>
            <ShapeFilesDetailsTableTD>
              {formatDate(issue.created)}
            </ShapeFilesDetailsTableTD>
            <ShapeFilesDetailsTableTD>
              {determineAction(issue, handleReview, handleView, psap)}
            </ShapeFilesDetailsTableTD>
          </ShapeFilesDetailsTableTR>
        ))}
      </ShapeFilesDetailsTableBody>
    </ShapeFilesDetailsTable>
  );
};

export default ShapeFilesDetails;
